import reportmonthlyperformanceService from '../../../services/reportmonthlyperformanceService';
import {
    setReportmonthlyperformanceLoading,
    setReportmonthlyperformanceError,
    setReportmonthlyperformanceData,
    setReportmonthlyperformanceUnifiedData,
    setReportmonthlyperformanceSettings,
    setReportmonthlyperformanceDownloading,
    setReportmonthlyperformanceClassicFilters,
} from './reportmonthlyperformanceSlice';

export const fetchSettings = () => async (dispatch, getState) => {
    try {
        if (!getState().reportmonthlyperformance.isSettingsInitialized) {
            dispatch(setReportmonthlyperformanceLoading(true));
            const response = await reportmonthlyperformanceService.getSettings();
            dispatch(setReportmonthlyperformanceSettings(response));
            dispatch(setReportmonthlyperformanceClassicFilters(response?.classic_filters || {}));
        }
        return getState().reportmonthlyperformance.classicFilters;
    } catch (error) {
        dispatch(setReportmonthlyperformanceError({
            message: error.message || 'Failed to fetch settings',
            errors: error.errors || {},
        }));
        return {};
    } finally {
        dispatch(setReportmonthlyperformanceLoading(false));
    }
};

export const fetchReportmonthlyperformance = () => async (dispatch, getState) => {
    try {
        const state = getState().reportmonthlyperformance;
        if (!state.isSettingsInitialized) {
            await dispatch(fetchSettings());
        }

        dispatch(setReportmonthlyperformanceLoading(true));
        const classicFilters = getState().reportmonthlyperformance.classicFilters;
        const response = await reportmonthlyperformanceService.getList({}, {}, classicFilters);
        dispatch(setReportmonthlyperformanceData(response));
        return response;
    } catch (error) {
        const serializedError = {
            message: error.message || 'An error occurred',
            errors: error.errors || {},
            status: error.status || 500,
        };
        dispatch(setReportmonthlyperformanceError(serializedError));
        throw serializedError;
    } finally {
        dispatch(setReportmonthlyperformanceLoading(false));
    }
};

export const fetchFullReport = () => async (dispatch, getState) => {
    try {
        const state = getState().reportmonthlyperformance;
        if (!state.isSettingsInitialized) {
            await dispatch(fetchSettings());
        }

        dispatch(setReportmonthlyperformanceLoading(true));
        const classicFilters = getState().reportmonthlyperformance.classicFilters;
        const response = await reportmonthlyperformanceService.getFullReport(classicFilters);
        dispatch(setReportmonthlyperformanceUnifiedData(response));
        return response;
    } catch (error) {
        const serializedError = {
            message: error.message || 'An error occurred',
            errors: error.errors || {},
            status: error.status || 500,
        };
        dispatch(setReportmonthlyperformanceError(serializedError));
        throw serializedError;
    } finally {
        dispatch(setReportmonthlyperformanceLoading(false));
    }
};

export const downloadReportmonthlyperformance = (type) => async (dispatch, getState) => {
    try {
        const state = getState().reportmonthlyperformance;
        dispatch(setReportmonthlyperformanceDownloading(true));
        const response = await reportmonthlyperformanceService.download(
            { export_type: type },
            {},
            state.classicFilters
        );
        return response;
    } catch (error) {
        const serializedError = {
            message: error.message || 'An error occurred',
            errors: error.errors || {},
            status: error.status || 500,
        };
        dispatch(setReportmonthlyperformanceError(serializedError));
        throw serializedError;
    } finally {
        dispatch(setReportmonthlyperformanceDownloading(false));
    }
};

export const changeClassicFilter = (name, value) => (dispatch, getState) => {
    const state = getState().reportmonthlyperformance;
    const classicFilters = { ...state.classicFilters };

    if (!classicFilters[name]) {
        return;
    }

    classicFilters[name] = {
        ...classicFilters[name],
        query: {
            ...classicFilters[name].query,
            ...value,
        },
    };

    dispatch(setReportmonthlyperformanceClassicFilters(classicFilters));
};

export const setDefaultFilter = () => () => {};

export const changeCondition = () => () => {};

export const addNewCondition = () => () => {};

export const updateOptionRule = () => () => {};

export const updateOptionValue = () => () => {};

export const removeCondition = () => () => {};

export const saveFilterCondition = () => () => {};
